import { render, staticRenderFns } from "./editAppointmentCategory.vue?vue&type=template&id=6be64e20&scoped=true"
import script from "./editAppointmentCategory.vue?vue&type=script&lang=js"
export * from "./editAppointmentCategory.vue?vue&type=script&lang=js"
import style0 from "./editAppointmentCategory.vue?vue&type=style&index=0&id=6be64e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be64e20",
  null
  
)

export default component.exports